/* eslint-disable no-template-curly-in-string */
import * as yup from 'yup';

import { isArray, isString, isUndefined } from 'lodash';

import { APPLICATION_NAMES, Application, Environment } from '../types';

declare const APPLICATIONS: Application[];

const alternativeEnvironmentValidation: yup.SchemaOf<Environment> = yup
  .mixed()
  .test({
    name: 'is_string_or_array',
    test(value: any) {
      if (isUndefined(value)) return true;

      if (isArray(value)) {
        const schema = yup
          .array()
          .of(
            yup.object().shape({
              title: yup.string().required(),
              url: yup.string().url().required(),
              badgeContent: yup.string().notRequired(),
            })
          )
          .min(1);

        schema.validateSync(value);

        return true;
      }

      if (isString(value)) {
        const schema = yup.string().url();

        schema.validateSync(value);

        return true;
      }

      return false;
    },
  })
  .notRequired();

const applicationConfigurationValidationSchema: yup.SchemaOf<Application[]> = yup
  .array()
  .of(
    yup.object().shape({
      name: yup
        .mixed()
        // @ts-ignore
        .oneOf(APPLICATION_NAMES)
        .required(),
      url: yup.string().url().required(),
      title: yup.string().notRequired(),
      tooltipText: yup.string().notRequired(),
      alternativeEnvironments: yup
        .object()
        .shape({
          development: alternativeEnvironmentValidation,
          testing: alternativeEnvironmentValidation,
          acceptance: alternativeEnvironmentValidation,
          production: alternativeEnvironmentValidation,
        })
        .notRequired(),
    })
  )
  .min(1)
  .required();

const validateApplicationConfiguration = (): true | { errorMessage: string } => {
  if (typeof APPLICATIONS === 'undefined')
    return { errorMessage: 'APPLICATIONS object not found.' };

  try {
    applicationConfigurationValidationSchema.validateSync(APPLICATIONS);
    return true;
  } catch (error) {
    if (error instanceof yup.ValidationError) return { errorMessage: error.message };
    throw error;
  }
};

export default validateApplicationConfiguration;
